export default "__VITE_ASSET__Cw$0YNj8__"